import Checkbox from "ant-design-vue/lib/checkbox"; // 加载 JS
import "ant-design-vue/lib/checkbox/style/css"; // 加载 CSS
import common from "./common";
import Vue from "vue";
Vue.use(Checkbox);
const policyMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false
  },
  data() {
    return {
      fieldObj: {},
      fieldPop: false,
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    }
  },
  created() {
    this.fieldObj = new window.$sk.Policy(this.field);
  },
  methods: {
    handleChange(e) {
      this.fieldObj.setValue(e.target.checked);
    }
  }
};
export default policyMixin;
